import { FAIcon } from "../core/components/faIcon.js";
import { Helper } from "../core/util/helper.js";
import { HTTPService, JsonResultClass } from "../core/util/httpManager.js";
import React from "react";
export class InstalledInfo extends React.Component<InstalledInfoProps, InstalledInfoState> {
    constructor(props) {
        super(props)
        this.state = {
            infoState: "Loading",
            errorMessage: null
        }
    }

    recheck = () => {
        this.setState({ infoState: "Loading" }, this.check)
    }

    private check = async () => {
        const result = await HTTPService.noBusyIndicator().get<JsonResultClass<string>>(this.props.checkUrl);
        if (result.Code == 0) {
            if (result.Data) {
                this.setState({ infoState: "IsInstalled" })
            } else {
                this.setState({ infoState: "IsNotInstalled" })
            }
            this.props.afterCheck(result.Data)
        } else {
            this.setState({ infoState: "Error", errorMessage: result.Message })
        }
    }

    componentDidMount() {
        this.check();
    }

    render() {
        const RED = "#e53935";
        const GREEN = "#2e7d32";
        const DEEP_RED = "#d50000";

        let style: React.CSSProperties = {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            borderStyle: "none",
            borderWidth: "3px",
            borderLeftWidth: "10px",
            padding: "5px",
            borderRadius: "var(--border-radius)"
        }
        let icon = <></>;
        let info = <></>;
        switch (this.state.infoState) {
            case "Loading":
                icon = <FAIcon name="spinner" prefix={"fas"} spins={true} attributes={["2x"]} />;
                break;
            case "IsNotInstalled":
                style.borderStyle = "solid";
                style.borderColor = RED;
                icon = <FAIcon name="times" prefix={"fas"} attributes={["2x"]} style={{ color: RED }} />;
                info = <label>{Helper.getTranslation("MST.UI.InstalledInfo.NotInstalled")}</label>
                break;
            case "IsInstalled":
                style.borderStyle = "solid";
                style.borderColor = GREEN;
                icon = <FAIcon name="check" prefix={"fas"} attributes={["2x"]} style={{ color: GREEN }} />;
                info = <label>{Helper.getTranslation("MST.UI.InstalledInfo.Installed")}</label>
                break;
            case "Error":
                style.borderStyle = "solid";
                style.borderColor = DEEP_RED;
                icon = <FAIcon name="bolt-lightning" prefix={"fas"} attributes={["3x"]} style={{ color: DEEP_RED }} />;
                info = <label>{this.state.errorMessage}</label>
                break;
        }

        icon = (
            <div style={{ width: "min-content" }} >
                {icon}
            </div>
        );

        return (
            <div style={style}>
                {icon}
                {info}
            </div>
        );
    }
}

interface InstalledInfoProps {
    checkUrl: string,
    afterCheck: (chatId: string) => void
}

interface InstalledInfoState {
    infoState: "Loading" | "IsInstalled" | "IsNotInstalled" | "Error";
    errorMessage: string;
}